export const settings = {
  selector: '.js-archive-filters',
  yearSelect: '.js-archive-year-select',
  monthSelect: '.js-archive-month-select'
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  const isYearly = element.dataset.yearly
  const isMonthly = element.dataset.monthly
  const year = element.dataset.year
  const yearSelect = element.querySelector( settings.yearSelect )
  let monthSelect = element.querySelector( settings.monthSelect )

  initYearSelect( yearSelect )

  if ( isYearly || isMonthly ) {
    initMonthSelect( monthSelect, parseInt( year, 10 ))
  }
}

/**
 *
 * @param {DOMNode} element
 * @param {int} year
 */
function initMonthSelect( element, year ) {
  let options = element.options
  for ( var i = 0; i < options.length; i++ ) {
    let option = options[i]
    if ( option.value && option.value.indexOf( year ) === -1 ) {
      element.remove( i )
      i--
    }
  }

  element.addEventListener( 'change', () => {
    const value = element.options[element.selectedIndex].value
    if ( value ) {
      window.location.href = value
    }
  })

  element.disabled = false
}

/**
 *
 * @param {DOMNode} element
 */
function initYearSelect( element ) {
  element.addEventListener( 'change', () => {
    const value = element.options[element.selectedIndex].value
    if ( value ) {
      window.location.href = value
    }
  })
}
